import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Image from 'next/image';

const BeniftContent = ({benefitsData}) => {
  return (
    <Tabs>
      <div className="flex flex-col lg:flex-row w-100 lg:flex-nowrap lg:space-x-10 benifit">
        <div className="lg:w-[43%] order-last lg:order-first">
          {/* <!-- tabs --> */}

          <TabList className="nav nav-tabs mb-12 space-y-2">
            {benefitsData.map((val) => (
              <Tab className="nav-item" key={val.id}>
                <button
                  className="nav-link nav-link--style-2 group relative flex w-full border-b border-jacarta-100 p-6 text-left dark:border-jacarta-600"
                  type="button"
                >
                  <Image
                    width={32}
                    height={32}
                    src={val.icon}
                    alt="items"
                    className="mx-2 pt-1"
                  />
                  <div>
                    <span
                      className="mb-2 mt-1 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white transition transition-colors">
                      {val.title}
                    </span>
                    <div className="nav-link-content hidden">
                      <p className="normal-case text-jacarta-500 dark:text-jacarta-300">
                        {val.description}
                      </p>
                    </div>
                  </div>
                </button>
              </Tab>
            ))}
            {/* End tab */}
          </TabList>
        </div>
        {/* End tablist */}

        <div className="flex items-center justify-center lg:w-[57%] order-first lg:order-last">
          {/* <!-- content --> */}
          <div className="tab-content flex-1">
            {benefitsData.map((val) => (
              <TabPanel>
                <div className=" relative">
                  <figure className="flex items-center justify-center">
                    <img
                      src={val?.image ?? "/images/benefits-default.png"}
                      alt="benifit"
                      className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600"
                    />
                    <img
                      src={val?.animationImage}
                      alt=""
                      className="absolute animate-spin-slow"
                    />
                  </figure>
                </div>
              </TabPanel>
            ))}
          </div>
        </div>
      </div>
    </Tabs>
  );
};

export default BeniftContent;
